import * as React from "react";
import { useNavigate } from "react-router-dom";
import urlPaths from "@/urlPaths";
import { KYCTemplate } from "@/templates/KYCTemplate";
import {
  createChecks,
  getApplicantAndToken,
  getChecks,
  getReports,
  IKycApi,
} from "@/services/api/kycApi";
import { getCase } from "@/services/api/caseApi";
import { Kyc } from "./KYC";

export const KYCPage: React.FC<{ caseId: string; signature: string | null }> = ({
  caseId,
  signature,
}) => {
  const navigate = useNavigate();

  const [busy, setBusy] = React.useState(false);

  const onDone = React.useCallback(() => {
    getCase({ caseId, signature }).then(
      (_data) => {
        navigate(urlPaths.form("kyc"));
      },
      (_) => {
        navigate(urlPaths.root());
      }
    );
  }, [caseId, signature, navigate]);

  const api: IKycApi = React.useMemo(() => {
    return {
      getApplicantAndToken: () => getApplicantAndToken({ caseId, signature }),
      createChecks: ({ variant }) => createChecks({ caseId, signature, variant }),
      getChecks: ({ checkId }) => getChecks({ caseId, signature, checkId }),
      getReports: ({ reportIds }) => getReports({ caseId, signature, reportIds }),
      downloadCheck: () => Promise.resolve({ error: undefined, data: {} }),
    };
  }, [caseId, signature]);

  return (
    <KYCTemplate busy={busy}>
      <Kyc api={api} setBusy={setBusy} onDone={onDone} />
    </KYCTemplate>
  );
};
